import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '@pixi/react';
import { MultiActionArrowContainer } from './multiActionArrowContainer';
export const MultiActionArrowsContainer = ({ actionTimerSeatIndexes }) => {
    return (_jsx(Container, { interactiveChildren: false, children: actionTimerSeatIndexes.map((seatIndex) => (_jsx(MultiActionArrowContainer, { seatIndex: seatIndex }, seatIndex))) }));
};
